import { render, staticRenderFns } from "./ModalPicture.vue?vue&type=template&id=276e2496"
import script from "./ModalPicture.vue?vue&type=script&lang=js"
export * from "./ModalPicture.vue?vue&type=script&lang=js"
import style0 from "./ModalPicture.vue?vue&type=style&index=0&id=276e2496&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports